import React, {
} from 'react';
import UserNotifications from 'pages/userNotifications';
import { NOTIFICATION_CATEGORIES } from 'constant/variables';

const UserNoti = () => {
  return (
    <UserNotifications
      category={NOTIFICATION_CATEGORIES.NOTIFICATION}
      title="Notification"
    />
  );
};

export default UserNoti;
